import { useEffect } from 'react';

import type { QueryResult } from '@apollo/client';

import { WebSocketConnectionState } from 'common/constants/webSocketConnectionState';
import { webSocketStateSubject } from 'common/helpers/webSocketState';

export default function useWsReconnectRefetch(queryResult: QueryResult): void {
  const { refetch, variables } = queryResult;

  useEffect(() => {
    const subscription = webSocketStateSubject.subscribe(wsState => {
      if (wsState === WebSocketConnectionState.OPEN) {
        refetch(variables);
      }
    });
    return () => {
      subscription?.unsubscribe();
    };
  }, [refetch, variables]);
}
